export enum VekilTipi {
    sahis = "Şahıs",
    buro = "Özel",
    kamu = "Kamu"
}
